export const pushToDataLayer = (event: Record<string, unknown>, _options?: { debug?: boolean }) => {
	if (typeof window === 'undefined') return

	try {
		window.dataLayer = window.dataLayer || []

		setTimeout(() => {
			window.dataLayer.push(event)
		}, 1500)
	} catch (err) {
		console.warn('Ошибка при push в dataLayer', err)
	}
}
